import React, { FC } from 'react';
import { Link } from 'react-router-dom';

type Props = {
    className?: string; // Use string type for className
};

const SocialLinks: FC<Props> = ({ className }) => {
    return (
        <ul className={`${className}`}>
            <li>
                <Link target="_blank" to={'https://www.facebook.com/gardenoflifecommunity/'}>
                    <i className="fa-brands fa-facebook-f"></i>
                </Link>
            </li>
            <li>
                <Link target="_blank" to={'https://twitter.com/_gardenoflife_'}>
                    <i className="fa-brands fa-x-twitter"></i>
                </Link>
            </li>
            <li>
                <Link target="_blank" to={'https://www.instagram.com/gardenoflifeofficial/'}>
                    <i className="fa-brands fa-instagram"></i>
                </Link>
            </li>
            <li>
                <Link target="_blank" to={'https://www.youtube.com/@gardenoflifeofficial'}>
                    <svg width="17" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="YouTube">
                        <path
                            d="M19.3846 0H4.61538C2.06769 0 0 2.128 0 4.75V14.25C0 16.872 2.06769 19 4.61538 19H19.3846C21.9323 19 24 16.872 24 14.25V4.75C24 2.128 21.9323 0 19.3846 0ZM22.1538 14.25C22.1538 15.8175 20.9077 17.1 19.3846 17.1H4.61538C3.09231 17.1 1.84615 15.8175 1.84615 14.25V4.75C1.84615 3.1825 3.09231 1.9 4.61538 1.9H19.3846C20.9077 1.9 22.1538 3.1825 22.1538 4.75V14.25Z"
                        />
                        <path
                            d="M14.7323 7.84683L11.0585 5.71883C10.4769 5.38633 9.79385 5.38633 9.22154 5.73783C8.64923 6.07983 8.30769 6.69733 8.30769 7.38133V11.6753C8.30769 12.3593 8.64923 12.9768 9.23077 13.3188C9.51692 13.4898 9.84 13.5753 10.1538 13.5753C10.4677 13.5753 10.7815 13.4898 11.0677 13.3188L14.7415 11.1623C15.3231 10.8203 15.6738 10.2028 15.6738 9.50933C15.6738 8.81583 15.3231 8.19833 14.7323 7.85633V7.84683ZM10.1538 11.6658V7.37183L13.8277 9.49983L10.1538 11.6658Z"
                        />
                    </svg>
                </Link>
            </li>
        </ul>
    );
};

export default SocialLinks;
